import { useApp } from '../app-context';
import { Utils } from '../Utils';
import './ClaimsList.scss';
import { claim_event, claim_sub_event } from '../translator';
import { ClaimStatusLabel } from './ClaimStatusText';
import { ClaimTracker } from './ClaimTracker';
import { TSAccordion } from './commons';

const Claim = function ({ claim, claimClasses, onClick }) {
    const [, dispatcher] = useApp();

    // let eventType = claim?.eventType && (claim_event[claim?.eventType] || "") && claim_event[claim?.eventType];
    // let eventSubType = claim?.eventSubType && (claim_sub_event[claim?.eventSubType] || "");

    const handleContinueClaim = (e) => {
        e.stopPropagation();
        e.preventDefault();
        dispatcher({ action: 'showPage', params: { id: 'botClaim', props: { botScript: "", botToken: claim.botClaimSessionId } } })
    }

    const handleMissingDocs = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (claim?.activeDocumentRequestRef) {
            window.open(claim?.activeDocumentRequestRef, '_blank');
        }
    }

    let petName = claim?.pet?.name || 'ללא שם';

    const eventTypeStr = (eventType) => {
        let ret = "";
        switch (eventType) {
            case 'accident':
                ret = 'תאונה';
                break;
            case 'illness':
                ret = 'מחלה';
                break;
            case 'owner':
                ret = 'פנסיון';
                break;
            case 'thirdparty':
                ret = "צד ג'";
                break;
            case 'dead':
                ret = 'מוות חיה';
                break;
            }
            return ret;
    };

    let eventType = eventTypeStr(claim?.eventType);

    return (
        <div className={"claim" + (claimClasses ? " " + claimClasses : "")} onClick={onClick?.bind(null, claim)}>
            {/* <div className="avatar"><img src={`/img/avatar-${claim?.pet?.details?.type}.svg`} alt="" /></div> */}
            <div className="content">
                <div className="name">{petName}</div>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px"}}>
                    <div className="date">{Utils.isoDateToDateString(claim?.openedAt)}</div>
                    <img className="plus" src="/img/tracker/icon-plus.svg" alt="plus" style={{display: "none"}} />
                </div>
                {/* <div className="details">
                    {`${eventType || ""}${eventType && eventSubType ? ", " : ""}${eventSubType || ""}`}
                </div> */}
            </div>
            <div className="details">
                {eventType}
            </div>
            {[15, 20, 21].indexOf(claim.status) < 0 ?
                <ClaimTracker claim={claim} />
                :
                undefined
            }

            <ClaimStatusLabel claim={claim} />

            {claim.status === -1 ?
                <div className="claim-button">
                    <button className="regular-button menu-item claim-btn" onClick={handleContinueClaim}>המשך להגשת
                        תביעה
                    </button>
                </div>
                :
                claim.status === 1 && claim?.activeDocumentRequestRef ?
                    <div className="claim-button">
                        <button className="regular-button menu-item claim-btn" onClick={handleMissingDocs}>צירוף מסמכים
                            חסרים
                        </button>
                    </div>
                    :
                    undefined
            }
        </div>
    )
};

const ClaimsList = function ({ claims, title, claimClasses }) {
    const [state, dispatcher] = useApp();

    const handleClick = (claim, e) => {
        e.preventDefault();
        dispatcher({ action: "closePage", params: { id: "main" } });
        dispatcher({ action: "showPage", params: { id: "claim", props: { claim: claim, claims: claims } } });
    };

    return (
        <div className="claims-list">
            <TSAccordion title={title} forceToggle={true} uiParams={state.uiParams}>
                <div className="list">
                    {claims.map(v => <Claim claim={v} key={"claim" + v.id} claimClasses={claimClasses + (v.status !== -1 ? " clickable" : "")} onClick={v.status !== -1 ? handleClick : undefined} />)}
                </div>
            </TSAccordion>
        </div>
    );
};

export { Claim };
export { ClaimsList };